import React from 'react';

const FooterRA = () => (
  <div style={{ fontSize: 9, marginTop: 40 }}>
    <p style={{ marginBottom: 4 }}>
      <b>NOTA</b>: Las condiciones establecidas en este documento deben considerarse para la elaboración del plan de actividades del
      productor del plan general de manejo del cultivo certificado a nivel de la organización. Una copia de esta hoja debe entregarse al
      productor una vez requisitada.
    </p>
    <p style={{ marginBottom: 4 }}>
      Basados en el reglamento interno de la verificación y certificación y al estándar RA V.1.4. se categorizará el tipo de criterio
      presente:
    </p>

    <p style={{ marginBottom: 4 }}>
      Si los <b>requisitos fundamentales</b> no son cumplidos en su totalidad el productor no puede acceder a la certificación.
    </p>

    <p style={{ marginBottom: 4 }}>
      Si los <b>requisitos especializados</b> no son cumplidos son motivos para establecer condiciones que deben evaluarse lo más pronto
      posible o según el caso sancionar al productor. Definir fechas de verificación de cumplimiento de las condiciones o de la sanción.
    </p>

    <p style={{ marginBottom: 4 }}>
      Si los <b>Requisitos de mejora continua</b> no se cumplen en su totalidad son casos que merecen condiciones u observaciones (casos que
      no afecta la calidad del producto certificado), puede solventarse según el tiempo que requieran las acciones correctivas anotar las
      fechas de verificación y darle seguimiento.
    </p>

    <p style={{ marginBottom: 4 }}>Para el caso de la Verificación C.A.F.E PRACTICES si se presenta un Cero Tolerancia (ZT) se anotará.</p>
  </div>
);

export default FooterRA;
